import AdminService from "@/services/Admin.service"
import { SET_FORM_ADMIN, SET_FORM_REPORT } from './mutation-types'

const _ = require('lodash')

let _token = localStorage.getItem('token');



const AdminModule = {
    state: () => ({
        formAdmin:{
            email: '',
            password: '',
        },
        formReport:{
            "Nome": "",
            "CPF": "",
            "Email": "",
            "CellPhone": "",
            "DateAdd": "",
            // "DataInicio": "2021-01-21",
            // "DataFim": "2021-09-21"
        },
        token: _token,
        dataReport: [],
    }),
    mutations: {
        [SET_FORM_ADMIN](state, formAdmin) {
            state.formAdmin = formAdmin
        },
        [SET_FORM_REPORT](state, formAdmin) {
            state.formAdmin = formAdmin
        },
    },
    actions: {
        async auth(context) {
            var service = new AdminService();
            var statusCode, res

            try {
                res = await service.auth(context.state.formAdmin);

                context.state.token = res.data.token || null;
                statusCode = res.status;                
                
            } catch (error) {
                context.state.token = null;
                statusCode = error.response.status;                
            }

            // Save token
            localStorage.setItem('token', context.state.token);

            // Limpa o formulário
            context.commit(SET_FORM_ADMIN, {email: '', password: ''});

            // Check status code
            if (statusCode == 200) {
                return { status: true, message: "Usuário autenticado"}
            } else if (statusCode == 400) {
                return { status: false, message: "Usuário ou senha incorretos"}
            } else {
                return { status: false, message: "Erro ao autenticar"}
            }
        },

        logout(context) {
            localStorage.removeItem('token');
            context.state.token = null; 
            return { status: true, message: "Usuário deslogado"}
        },

        async getDataReport(context, withoutFilter = false) {
            var service = new AdminService();
            var statusCode, res;

            var form        = _.cloneDeep(context.state.formReport);

            if(withoutFilter){
                form = {};
            }

            try {
                res = await service.getDataReport(form, context.state.token);
                statusCode = res.status;                

            } catch (error) {
                statusCode = error.response.status;
            }

            // formata os dados
            // var data = formatData(res.data);
            var data = res.data;

            // Check status code
            if (statusCode == 200) {
                context.state.dataReport = data;
                return { status: true, message: "Ok", data: data, auth: true}
            } else if (statusCode == 400) {
                return { status: false, message: "Erro na consulta", data:[], auth: true}
            }else if (statusCode == 401) {
                return { status: false, message: "Não autorizado", auth: false}
            } else {
                return { status: false, message: "Erro na consulta 2", data:[], auth: true}
            }
        },

    },
    getters: {
        formAdmin: state => state.formAdmin,
        token: state => state.token,
        formReport: state => state.formReport,
        dataReport: state => state.dataReport,
    }
}


const formatData = (data) => {
    if(!data){
        return []
    }
    return _.map(data, (item) => {
        item.cpf                = formataCPF(item.cpf);
        item.zip_code           = formataCEP(item.zip_code);
        item.privacy_consent    = item.privacy_consent ? "1" : "0";
        item.media_consent      = item.media_consent ? "1" : "0";
        item.acceptRegulation   = item.acceptRegulation ? "1" : "0";
        item.birth_date         = formataDate(item.birth_date);
        item.mobile_phone       = formataCelular(item.mobile_phone);
        item.dateAdd            = formataDate(item.dateAdd);
        return item;
    })
}

function formataCPF(cpf){
    //retira os caracteres indesejados...
    cpf = cpf.toString().replace(/[^\d]/g, "");
  
    //realizar a formatação...
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  function formataCEP(str){
	var re = /^([\d]{2})\.*([\d]{3})-*([\d]{3})/; // Pode usar ? no lugar do *

	if(re.test(str)){
		return str.replace(re,"$1$2-$3");
	}else{
		return str;
	}
	
}

function formataDate(date){
    var today  = new Date(date);

    return today.toLocaleDateString("pt-br");
    
}

function formataCelular(v) {

    if(typeof v !== 'string'){
        return v;
    }
    
    var r = v.replace(/\D/g, "");
    r = r.replace(/^0/, "");
    if (r.length > 10) {
      r = r.replace(/^(\d\d)(\d{5})(\d{4}).*/, "$1 $2-$3");
    } else if (r.length > 5) {
      r = r.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "$1 $2-$3");
    } else if (r.length > 2) {
      r = r.replace(/^(\d\d)(\d{0,5})/, "$1 $2");
    } else {
      r = r.replace(/^(\d*)/, "($1");
    }
    return r;
  }


export default AdminModule;
